import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { OcmPoi, OcmPoiQuery } from '../stores/types/ocm.interface';

// Open Charge Map goes through the FESH nginx `/ocm/` location (chargelab-aws), which adds the
// API key server side, the same way `/maps/api` does for Google Maps. Locally, setupProxy.js
// forwards /ocm to the stack in REACT_APP_ENDPOINT.
const OCM_PROXY_BASE_URL = '/ocm/v3';
const MAX_RESULTS = 250;
// ~110 m; rounding the origin lets nearby searches share the RTK Query cache
const COORDINATE_PRECISION = 3;
const POI_CACHE_SECONDS = 5 * 60;

const roundCoordinate = (value: number) => Number(value.toFixed(COORDINATE_PRECISION));

export const ocmApi = createApi({
  reducerPath: 'ocm',
  baseQuery: fetchBaseQuery({ baseUrl: OCM_PROXY_BASE_URL }),
  keepUnusedDataFor: POI_CACHE_SECONDS,
  endpoints: (builder) => ({
    fetchNearbyPois: builder.query<OcmPoi[], OcmPoiQuery>({
      query: ({ latitude, longitude, radiusKm, connectionTypeIds, levelId }) => ({
        url: '/poi/',
        method: 'GET',
        params: {
          output: 'json',
          latitude: roundCoordinate(latitude),
          longitude: roundCoordinate(longitude),
          distance: radiusKm,
          distanceunit: 'KM',
          maxresults: MAX_RESULTS,
          compact: false,
          verbose: false,
          ...(connectionTypeIds.length > 0 && { connectiontypeid: connectionTypeIds.join(',') }),
          ...(levelId !== undefined && { levelid: levelId }),
        },
      }),
    }),
  }),
});

export const { useLazyFetchNearbyPoisQuery } = ocmApi;
